module.exports = __webpack_public_path__ + "img/ric.598f2ad8.svg";